import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PaymentsView from './PaymentsView';
import { Creators as pendingPaymentActions } from '../../../domain/useCases/payments/getPendingPayments';
import { Creators as paidPaymentActions } from '../../../domain/useCases/payments/getPaidPayments';
import { Creators as requestBenefitActions } from '../../../domain/useCases/payments/getBenefitInstallments';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { formatDiscountBenefitItems } from './modules/PayOnline/helpers';

const PaymentsViewController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);

  const { data: dataBenefit, isLoading: isLoadingBenefit } = useSelector(
    (state: any) => state.getBenefitInstallments
  );

  const {
    data: dataPending,
    isLoading: isLoadingPending,
    isSuccess: isSuccessPending,
    error: dataPendingError
  } = useSelector((state: any) => state.getPendingPayments);

  const { data: dataPaid, isLoading: isLoadingPaid } = useSelector(
    (state: any) => state.getPaidPayments
  );
  const period = useSelector(
    (state: any) => state?.profile?.data?.academic?.period?.description
  );

  const handlerRedirect = (route: string, data?: any) => {
    GoogleAnalytics.writeLog(
      `GoTo-${route.replaceAll('pagos/', '')}`,
      'redirect',
      route
    );
    if (data) history.push({ pathname: route, state: data });
    else history.push(route);
  };

  useEffect(() => {
    GoogleAnalytics.writeLog('Menu-Pagos', 'Menu');
    dispatch(requestBenefitActions.getBenefitInstallments());
    dispatch(pendingPaymentActions.getPendingPayments());
    dispatch(paidPaymentActions.getPaidPayments(period));
  }, []);

  useEffect(() => {
    if (dataPending && dataBenefit) {
      const response = formatDiscountBenefitItems(
        dataPending?.pendingPayments,
        dataBenefit?.requestBenefit
      );
      setItems(response);
    }
  }, [dataPending, dataBenefit]);

  const periodsPending: string[] = [];
  dataPending?.pendingPayments?.items.forEach((item: any) => {
    if (!periodsPending.includes(item.periodDesc))
      periodsPending.push(item.periodDesc);
  });

  periodsPending.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

  const periodsPaid: string[] = [];
  dataPaid?.paidPayments?.items.forEach((item: any) => {
    if (!periodsPaid.includes(item.periodDesc))
      periodsPaid.push(item.periodDesc);
  });

  periodsPaid.sort((a, b) => parseInt(b, 10) - parseInt(a, 10));

  const loading = isLoadingPaid || isLoadingPending || isLoadingBenefit;
  const hasProntoPago = dataPending?.pendingPayments?.items?.some(
    (i: any) => i.hasDiscountProntoPago === true
  );

  return (
    <PaymentsView
      handlerRedirect={handlerRedirect}
      pendingPayments={items}
      dataError={dataPendingError}
      pendingSummary={dataPending?.pendingPayments?.summary}
      paidPayments={dataPaid?.paidPayments?.items}
      hasProntoPago={hasProntoPago}
      dataBenefit={dataBenefit?.requestBenefit}
      periodsPending={periodsPending}
      periodsPaid={periodsPaid}
      isLoadingPending={isLoadingPending}
      isSuccessPending={isSuccessPending}
      isLoadingPaid={isLoadingPaid}
      loading={loading}
    />
  );
};

export default PaymentsViewController;
